<template>
  <div class="search">
    <div class="container">
      <Title class="search__title" suptitle="Résultat de recherche pour:"
        >"{{ getSearchTerm() }}"
      </Title>
    </div>
    <RecipeGrid :recipes="recipes" v-if="recipes" />
  </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import RecipeGrid from "@/components/listing/RecipeGrid.vue";
export default {
  name: "Search",
  components: { RecipeGrid, Title },
  data() {
    return {
      recipes: false,
      slug: this.$route.params.slug
    };
  },
  mounted() {
    this.fetchPage();
  },
  watch: {
    $route() {
      this.slug = this.$route.params.slug;
      this.fetchPage();
    }
  },
  methods: {
    getSearchTerm() {
      return decodeURIComponent(this.slug);
    },
    async fetchPage() {
      let endpoint =
        typeof this.slug !== "undefined" ? "search/" + this.slug : "search/";

      const response = await this.getApi(endpoint);
      this.recipes = response;
    }
  }
};
</script>
<style lang="scss" scoped>
.search {
  &__title {
    text-align: center;
  }
}
</style>
